import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import PropTypes from 'prop-types';
import config from '@config';
import { SplashScreen } from '@components';
import { ROUTES } from '@constants';
import { UserService } from '@services';
import utils from '@utils';

const SignupRedirect = ({ redirectPolicy, history, operation }) => {
	const { instance } = useMsal();
	const { location : { search } } = history;

	const searchParams = new URLSearchParams(search);

	const msalRedirect = (token, clientDetails = {}) => {
		const { EmailAddress, FirstName, LastName } = clientDetails;
		instance.handleRedirectPromise()
			.then(() => {
				const uxConfigData = {
					hiddenInputs : ['clientSignupToken'],
				};

				if (EmailAddress) {
					uxConfigData.disabledInputs = ['email'];
				}

				instance.loginRedirect({
					authority            : redirectPolicy,
					scopes               : config.ENV_OPTIONS.adb2c.scopes,
					redirectUri          : ROUTES.ADCallback,
					prompt               : 'login',
					loginHint            : EmailAddress || '',
					state                : utils.encodeADState({ operation }),
					extraQueryParameters : {
						...Object.fromEntries(searchParams),
						clientSignupToken : token || '',
						firstName         : FirstName || '',
						lastName          : LastName || '',
						uxConfig          : utils.encodeADState(uxConfigData),
					},
				});
			})
			.catch(() => {
				history.push('/');
			});
	};

	const handleClientSignupToken = (token) => {
		// If the token is a signup token, call the verify token service to get client details
		UserService.verifyClientSignupToken(token)
			.then(({ data : clientData }) => {
				msalRedirect(token, clientData);
			}).catch(() => {
				history.push('/');
			});
	};

	useEffect(() => {
		const adAccount = instance.getAccountByHomeId(localStorage.getItem('homeAccountId'));
		if (adAccount) {
			history.replace('/overview');
			return;
		}

		const token = searchParams.get('token');

		if (!token) {
			msalRedirect();
			return;
		}

		// Delete the `token` parameter so that we can forward the remaining params.
		searchParams.delete('token');
		handleClientSignupToken(token);
	}, []);

	return (
		<div id="ad-signup">
			<SplashScreen />
		</div>
	);
};

SignupRedirect.propTypes = {
	redirectPolicy : PropTypes.string.isRequired,
	history        : PropTypes.object.isRequired,
	operation      : PropTypes.string.isRequired,
};

export default SignupRedirect;
